module.exports = __webpack_public_path__ + "assets/img/zh-Hant-11b41709.png";